import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./anim";
import { WORKSHOPS } from "@/data";

export default function Workshops() {
  const scrollToContact = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="workshops" className="relative bg-ink py-24 md:py-36 border-t border-line-d" data-testid="workshops-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <Overline>The Work</Overline>
            <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl text-sand tracking-tight leading-tight">
              Workshops designed for the moments that matter.
            </h2>
          </div>
          <p className="text-muted-d max-w-xs text-base leading-relaxed">
            Every programme is shaped around your team — these are our foundations.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5">
          {WORKSHOPS.map((w, i) => (
            <Reveal key={w.num} delay={i * 0.08}>
              <motion.button
                onClick={scrollToContact}
                className="group flex h-full w-full flex-col text-left overflow-hidden bg-ink-soft border border-line-d hover:border-terra transition-colors duration-500"
                data-testid={`workshop-card-${i}`}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={w.image}
                    alt={w.title}
                    className="absolute inset-0 h-full w-full object-cover img-treatment transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-soft via-ink-soft/20 to-transparent" />
                  <span className="absolute top-5 left-5 font-mono text-[11px] tracking-[0.2em] text-terra">{w.num}</span>
                </div>

                <div className="flex flex-1 flex-col p-7">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display text-3xl md:text-4xl text-sand leading-tight">{w.title}</h3>
                    <ArrowUpRight size={22} className="mt-1 shrink-0 text-muted-d group-hover:text-terra group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500" />
                  </div>
                  <p className="mt-2 font-mono text-[10px] tracking-[0.15em] uppercase text-muted-d">{w.duration}</p>
                  <p className="mt-4 text-muted-d text-sm leading-relaxed">{w.body}</p>
                  {w.suited && (
                    <p className="mt-5 pt-5 border-t border-line-d text-sm leading-relaxed">
                      <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-terra">Best suited for</span>
                      <span className="block mt-1 text-sand">{w.suited}</span>
                    </p>
                  )}
                </div>
              </motion.button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
